export const SET_VIEWING_PARTICIPANT = 'setViewingParticipant';
